import React from 'react';

import MainHeader from './mainHeader';
import NavLink from './navLinks';


import './MainNavigation.css';
import { useLocation, Link } from 'react-router-dom/cjs/react-router-dom.min';


const MainNavigation = (props) => {

  const location = useLocation(); // Get the current Location (route)

  // Conditionally change the text based on the route
  const changeNavText = () => {
    switch (location.pathname) {
      case '/tso':
        return 'Цогчэн';
        // return 'Дарьганга сумын хийд'
      case '/badma':
        return 'Бадма Ёга дацан';
        // return 'Түвшиншируу сумын хийд'
      case '/dashi':
        return 'Дашчойнпэл дацан';
        // return 'Онгон сумын хийд'
      case '/gunga':
        return 'Гунгаачойлин дацан';
        // return 'Баяндэлгэр сумын хийд'
      case '/idga':
        return 'Идгаачойнзэнлин дацан';
        // return 'Уулбаян сумын хийд'
      case '/jan':
        return 'Жанрайсиг дацан';
        // return 'Эрдэнэцагаан сумын хийд'
      case '/mam':
        return 'Мамба дацан'
        // return 'Түмэнцогт сумын хийд'
        default:
          // return 'Mongolian National Buddhist Center'
          return 'Монголын Бурханы Шашны Төв'
          // return 'Сүхбаатар аймгийн бурханы шашны төв'
    }
  }
  
  return (
    <MainHeader>
      <main className='nav-header'>
      <div className='main-nav-container'>
        <div className='nav-img-container' title='Home'>
            <Link to='/'><img src="/image/logo.PNG" alt="logo"/></Link>        
        </div> 

        <div className='nav-title-container'>  
          <h1>Гандан<span>тэгчэнлин хийд</span></h1>
          {/* <h1 className='gandantegchenlin'>Гандантэгчэнлин хийд</h1> */}
          {/* <h1 className='gandantegchenlin'>Эрдэнэмандал хийд</h1> */}
          <h2 className='gandan-hiid'>Гандан Хийд</h2>
          {/* <h2 className='gandan-hiid'>Эрдэнэмандал Хийд</h2> */}
          <h3 className='gandan'>Гандан</h3>
          {/* <h3 className='gandan'>Эрдэнэмандал</h3> */}
          <p>{changeNavText()}</p>
        </div>

        <div className='name-links'>     
          <NavLink />   
        </div>
      </div>
      </main>  
    </MainHeader>
  )
}

export default MainNavigation;